import axios from 'axios'

import { API_URL } from '@/config/api.config'

import keycloak from '@/auth/keycloak'
import { toastError } from '@/utils/toastError'

const instance = axios.create({
	baseURL: API_URL
})

instance.interceptors.request.use(async config => {
	if (keycloak?.token) {
		await keycloak.updateToken(30)
		config.headers.Authorization = `Bearer ${keycloak.token}`
	}

	return config
})

instance.interceptors.response.use(
	response => response,
	error => {
		const status = error?.response?.status

		if (status === 403) {
			toastError(
				`Error ${status}: Access denied. Please contact Technical Support`,
				{
					toastId: error.response?.data?.error,
					className: '!min-w-[250px]'
				}
			)
		}

		return Promise.reject(error)
	}
)

export default instance
